import { createContext, useContext, useState, useEffect } from 'react';
import { api, setToken, clearToken } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('m4b_access_token');
      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }
      const response = await api.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      console.log('Auth check failed:', error.message);
      clearToken();
      setUser(null);
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    const { user: userData, access_token } = response.data;
    
    // Save token to localStorage
    if (access_token) {
      setToken(access_token);
    }
    
    setUser(userData);
    return userData;
  };

  const loginWithGoogle = async (credential) => {
    const response = await api.post('/auth/google', { credential });
    const { user: userData, access_token } = response.data;
    
    // Save token to localStorage
    if (access_token) {
      setToken(access_token);
    }
    
    setUser(userData);
    return userData;
  };

  const register = async (name, email, password) => {
    const response = await api.post('/auth/register', { name, email, password });
    const { user: userData, access_token } = response.data || {};
    
    if (userData?.email_verified) {
      // Save token to localStorage
      if (access_token) {
        setToken(access_token);
      }
      setUser(userData);
    } else {
      setUser(null);
    }
    return response.data;
  };

  const logout = () => {
    api.post('/auth/logout').catch(() => {});
    clearToken();
    setUser(null);
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
  };

  const refreshUser = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      console.error('Failed to refresh user:', error);
      // Non cancellare il token - potrebbe essere un problema temporaneo
      // clearToken();
      // setUser(null);
    }
  };

  const value = {
    user,
    loading,
    login,
    loginWithGoogle,
    register,
    logout,
    refreshUser,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
